"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HintLexer =
/** @class */
function () {
  function HintLexer(tokens, onEmit) {
    this.callback = onEmit;
    this.next = tokens.next();
    this.tokenIterator = tokens;
  }

  HintLexer.prototype.done = function () {
    return this.next.done;
  };

  HintLexer.prototype.emit = function (token) {
    this.callback(token);
  };

  HintLexer.prototype.ignore = function () {
    this.next = this.tokenIterator.next();
  };

  HintLexer.prototype.pop = function () {
    var token = this.next.done ? null : this.next.value;
    this.next = this.tokenIterator.next();
    return token;
  };

  HintLexer.prototype.peek = function () {
    return this.next.done ? null : this.next.value;
  };

  return HintLexer;
}();

exports.HintLexer = HintLexer;